import React from "react";
import CommingSoon from "../../Components/layouts/comming.soon";

const HowWeWork = () => {
  return <CommingSoon />;
};

export default HowWeWork;
